<template>
    <bot-spinner v-model="spinner" class="mt-2 bot-center text-right">
        <v-alert dense text type="warning" class="mt-2">
            Nhất nút "Xác nhận" để chắc chắn rằng bạn muốn đăng xuất!
        </v-alert>
        <v-btn color="primary" @click="submit">Xác nhận</v-btn>
    </bot-spinner>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            authen: {
                logout: "authen/logout",
            },
        },
    },
    sms: {
        success: "Logout success!",
    },
};
const df = cafe.default;

export default {
    name: "Logout",

    components: {
        "bot-spinner": BotSpinner,
    },

    // this is state
    data() {
        return {
            setCookie: this.$options.filters.setCookie,
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    methods: {
        async submit() {
            this.spinner.visible = true;
            const dp = this.$store.dispatch;
            let res_logout = await dp(df.sp.authen.logout);
            this.spinner.visible = false;
            let text = res_logout.error;
            if (res_logout.error)
                return dp(df.sp.snb, { text, color: "error" });
            let { SessionID } = res_logout.data;
            let ck = {
                ckName: "client-id",
                ckValue: SessionID,
                isUpdate: true,
            };
            this.setCookie(ck);
            text = cafe.sms.success;
            dp(df.sp.snb, { text, color: "success" });
            window.location.href = "/login";
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
::v-deep .v-input {
    flex: unset;
    min-width: 350px;
}
</style>



// WEBPACK FOOTER //
// logout.vue